import React, { Component, useEffect, useRef } from "react";
import { Link } from 'react-router-dom';
import WithConsumer from '../context/WithConsumer';
import MobileMenu from '../partials/MobileMenu';
import DesktopMenu from '../partials/DesktopMenu';

const Head = ({ context }) => {
	
	const bannerRef = useRef(null);
	
	useEffect(() => {
        window.addEventListener('scroll', function(){
	        if (window.pageYOffset > 48) {
		        document.body.classList.add('state-site-scrolled');
	        } else {
		        document.body.classList.remove('state-site-scrolled');
	        }
        });
        
        window.addEventListener('resize', handleResize);
        
        handleResize(); 
        
    },[]); 
    
    const handleResize = () => {
	    	    
	    const root = document.querySelector(':root');
	    			
	    if (!bannerRef.current) {
		    
		    root.style.setProperty('--header-height', '0rem');
	    
	    } else {
		    
		    root.style.setProperty('--header-height', (Math.floor(bannerRef.current.clientHeight) / 16) + 'rem');
	    }
	    
	}
	
	if (context.menu) {
		const ctxMenu 	= () => context.menu;
		const menu 		= ctxMenu();
		
		const ctxSearchOpen = () => context.searchOpen;
		const searchOpen	= ctxSearchOpen();
				
		const ctxUser = () => context.user;
		const user = ctxUser();
		
		const ctxUserCart = () => context.user.cart;
		const userCart = ctxUserCart();
						
		if (menu.json === null) {
			context.getMenu(window.location.origin + '/wp-json/bloomingdales/v1/menu');
		}
	    
	    function handleMobMenuToggle(evt) {
		  	evt.preventDefault();
		  	context.toggleMobMenu();
	  	}
	  	function logout(evt){
		  	evt.preventDefault();
		  	context.logout();
	  	}
	  	
	  	function toggleLogin(evt) {
			evt.preventDefault();
			context.toggleLogin();
		}
		
		function toggleCart(evt) {
			evt.preventDefault();
			context.toggleCart();
		}
		
		function toggleSearch(evt) {
		  	evt.preventDefault();
		  	context.toggleSearch();
	  	}
	  	
	  	function submitSearch(evt) {
		  	evt.preventDefault();
		  	let value = document.getElementsByClassName('c-searchbar__input')[0].value;
		  	//value = value.replace(/[^\w\s]/gi, '');
		  	value = value.replace(/\s+/g, '--')
		  	if (value !== '') {
		  		context.submitSearch(value);
		  	}
	  	}
	  	
	  	function RegisterButton(){
			if (user.id === false || user.id === 'false' || user.id === null) {
				return (<Link to={{ pathname: '/customer-registration/' }} className="c-header__buttons__login">Register</Link>);
			} else {
				return null;
			}
		}
		
	  	function LoginButton(){
			if (user.id === false || user.id === 'false' || user.id === null || user.id === undefined || user.id === -1) {
				return (<a href="#" className="c-header__buttons__login" onClick={toggleLogin}>Login</a>);
			} else {
				return null;
			}
		}
		
		function LogOutButton(){
			if (user.id === false || user.id === 'false' || user.id === null || user.id === undefined || user.id === -1) {
				return null;
			} else {
				return (<a href="#" className="c-header__buttons__logout" onClick={logout}>Logout</a>);
			}
		}
		
		function AccountButton(){
			if (user.id === false || user.id === 'false' || user.id === null || user.id === undefined || user.id === -1) {
				return null;
			} else {
				return (<Link to={{ pathname: '/account/' }} className="c-header__buttons__account"><svg x="0px" y="0px" viewBox="0 0 16 16"><path d="M8,8c2.2,0,4-1.8,4-4s-1.8-4-4-4S4,1.8,4,4S5.8,8,8,8z M8,2c1.1,0,2,0.9,2,2S9.1,6,8,6 S6,5.1,6,4C6,2.9,6.9,2,8,2z M8,10c-2.7,0-8,1.3-8,4v2h16v-2C16,11.3,10.7,10,8,10z M2,14c0.2-0.7,3.3-2,6-2s5.8,1.3,6,2H2z"/></svg></Link>);
			}
		}
		
		function CartButton(){
			if (user.id == false || user.id == 'false' || user.id === null || user.id === -1) {
				return null;
			} else if (userCart) {
				
				return (<a href="#" className="c-header__buttons__cart" onClick={toggleCart}>Cart <span className="c-header__buttons__cart__count">({ userCart.count })</span></a>);
			} else {
				return null;
			}
		}
		
		function SearchButton(){
			return (<a href="#" className={`c-header__buttons__search ${searchOpen ? "state-search-open" : ""}`} onClick={toggleSearch}><svg x="0px" y="0px" viewBox="0 0 18 18"><path d="M12.77,11.27h-0.79L11.7,11c2.34-2.73,2.03-6.84-0.7-9.18s-6.84-2.03-9.18,0.7 s-2.03,6.84,0.7,9.18c2.44,2.09,6.04,2.09,8.48,0l0.27,0.28v0.79l5,4.99l1.49-1.49L12.77,11.27z M6.77,11.27 c-2.49,0-4.5-2.01-4.5-4.5s2.01-4.5,4.5-4.5s4.5,2.01,4.5,4.5c0,2.48-2.01,4.5-4.49,4.5C6.77,11.27,6.77,11.27,6.77,11.27z"/></svg></a>);
		}
		
		function InstagramButton(){
			return (<a href="https://www.instagram.com/bloomingdaleslighting" className="c-header__buttons__instagram" target="_blank"><svg x="0px" y="0px" viewBox="0 0 16 16"><path d="M12,0H4C1.79,0,0,1.79,0,4v8c0,2.21,1.79,4,4,4h8c2.21,0,4-1.79,4-4V4C16,1.79,14.21,0,12,0z M14,12 c0,1.1-0.9,2-2,2H4c-1.1,0-2-0.9-2-2V4c0-1.1,0.9-2,2-2h8c1.1,0,2,0.9,2,2V12z M8,4C5.79,4,4,5.79,4,8s1.79,4,4,4s4-1.79,4-4 S10.21,4,8,4z M8,10.5c-1.38,0-2.5-1.12-2.5-2.5S6.62,5.5,8,5.5s2.5,1.12,2.5,2.5S9.38,10.5,8,10.5z M12,3c-0.55,0-1,0.45-1,1 c0,0.55,0.45,1,1,1s1-0.45,1-1C13,3.45,12.55,3,12,3z"/></svg></a>);
		}
		
		if (menu.json !== null) {  	
		    return (
			    <>
			    	{menu.json.gbl_banner_message &&
				    	<div className="c-gbl-banner" ref={bannerRef} style={{backgroundColor: menu.json.gbl_banner_bg_colour}}>
				    		<p className="c-gbl-banner__text" dangerouslySetInnerHTML={{__html:menu.json.gbl_banner_message}} style={{color: menu.json.gbl_banner_text_colour}}></p>
				    		{menu.json.gbl_banner_link &&
					    		<>
					    			{menu.json.gbl_banner_link.indexOf('http') === -1 &&
					    				<Link to={{ pathname: menu.json.gbl_banner_link}} className="c-gbl-banner__overlay"></Link>
					    			}
					    			{menu.json.gbl_banner_link.indexOf('http') !== -1 &&
					    				<a href={menu.json.gbl_banner_link} className="c-gbl-banner__overlay"></a>
					    			}
					    		</>
				    		}
				    	</div>
			    	}
			    	<div className="c-header">
			    		<Link to="/" className="c-header__logo"></Link>
			    		<div className="c-header__buttons">
			    			<div className="c-header__buttons__left">
			    				<InstagramButton></InstagramButton>
								<SearchButton></SearchButton>
								<AccountButton></AccountButton>
							</div>
							<div className="c-header__buttons__right">
								<CartButton></CartButton>
								<LoginButton></LoginButton>
								<RegisterButton></RegisterButton>
								<LogOutButton></LogOutButton>
								<a href="#" className={`c-header__menu-button ${menu.mobileOpen ? "state-menu-open" : ""}`} onClick={handleMobMenuToggle}>
			    					<div className="c-header__menu-button__top"></div>
									<div className="c-header__menu-button__bottom"></div>
								</a>
							</div>
			    		</div>
			    		<MobileMenu></MobileMenu>
			    		<DesktopMenu></DesktopMenu>
					</div>
					<form className={`c-searchbar ${searchOpen ? "state-search-open" : ""}`} onSubmit={submitSearch}>
		    			<input name="s" className="c-searchbar__input" type="text" placeholder="Search for a product..." />
		    			<input name="submit" className="c-searchbar__submit" value="Search" type="submit" />
		    		</form>
		    		<div class={`c-header__force ${searchOpen ? "state-search-open" : ""}`}></div>
	    		</>
			)
		} else {
			return null;
		}
	} else {
		return null;
	}
}
export default WithConsumer(Head);